export default "__VITE_ASSET__9a18c5a6__"